import React from 'react';
import AntButton from 'components/AntButton/AntButton';

export const getBillingMaterialsErrorMessage = error =>
	error?.message ||
	(typeof error === 'string' ? error : 'Intente nuevamente en unos momentos.');

export default function BillingMaterialsLoadError({ error, onRetry }) {
	return (
		<div role='alert' data-testid='billing-materials-error'>
			<strong>No se pudieron cargar los materiales</strong>
			<p>{getBillingMaterialsErrorMessage(error)}</p>
			<AntButton
				size='small'
				onClick={onRetry}
				aria-label='Reintentar carga de materiales'
			>
				Reintentar
			</AntButton>
		</div>
	);
}
